import { postRequest } from "./request";

export function CertificateCreate(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `create-certificate`,
    token: userData.token,
    data: dataObject,
  }).then((response) => {
    return response ? response : undefined;
  });
}
